export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";